import { PROJDASH } from "../_constants/actionConstants";
import axios from "axios";
import { projWidgets } from "../_helpers/projWidgets";
import { getUUID } from "../_utils/generalUtils";
import { actionScripts } from "../_helpers/actionScripts";

/**
 * Loads all selected project dashboard widgets into redux store.
 * However, it does not load any data for the widgets - data is
 * loaded for display during rendering of the widgets.
 *
 * @param {Number} projectId
 * @param {String} projDashWidgets - Comma-separated single string of all selected widget types
 */
export const loadProjDashWidgets = (projectId, projDashWidgets) => (dispatch, getState) =>
  new Promise((resolve) => {
    dispatch({ type: PROJDASH.LOAD_WIDGETS });
    const selectedWidgetTypes = projDashWidgets.split(",");
    const widgets = selectedWidgetTypes.map((wt) => projWidgets[wt.trim()]);

    // Normalize widgets array by widgetType
    const payload = {};
    widgets.forEach((w) => (payload[w.widgetType] = w));
    dispatch({
      type: PROJDASH.LOAD_WIDGETS_FULFILLED,
      payload,
      projectId,
    });
    if (getState().dash.project[projectId] !== undefined) resolve(payload);
  });

/**
 * Updates projDash widget(s). Typically triggered by server-sent
 * SignalR action for projDashRefresh.
 * If no widgetType is provided, update all.
 *
 * @param {String} widgetType - a widgetType constant
 * @param {Number} projectId
 */
export const updateProjDashWidget =
  (widgetType = "ALL", projectId) =>
  (dispatch, getState) =>
    new Promise((resolve) => {
      dispatch({ type: PROJDASH.UPDATE_WIDGET });

      // Check if projDash exists, since dash.project[projectId] would
      // only exist if user had previously opened projDash. If this action
      // creator is called when projDash is still undefined, (like when
      // user saves ADR without ever having opened projDash) skip the
      // update routine - there's nothing to update.
      const projDashExists = getState().dash.project[projectId] !== undefined;
      if (projDashExists) {
        const widget = { ...getState().dash.project[projectId][widgetType] };
        // widget.dataProvider() is always an async func (returns Promise).
        // See docs for projWidgets. All exceptions are caught outside of here.
        widget.dataProvider(projectId).then((data) => {
          widget.data = data;
          dispatch({
            type: PROJDASH.UPDATE_WIDGET_FULFILLED,
            widget,
            projectId,
          });
          resolve();
        });
      }
    });

/**
 * Data accessor for project dashboard widgets with API calls.
 * 'widgetApiEndpoints' contains all API endpoints for widgets,
 * and this action creator generalizes all widget-related
 * calls to the server.
 *
 * @param {Widget} widget
 * @param {Number} projectId
 */
export const fetchProjDashWidgetData = (apiEndpoint, params) => (dispatch) =>
  new Promise((resolve) => {
    dispatch({ type: PROJDASH.FETCH_WIDGET_APIDATA });
    axios
      .get(apiEndpoint, params)
      .then((response) => {
        dispatch({
          type: PROJDASH.FETCH_WIDGET_APIDATA_FULFILLED,
        });
        console.log(PROJDASH.FETCH_WIDGET_APIDATA_FULFILLED);
        resolve(response.data);
      })
      .catch((err) => {
        const errorId = getUUID();
        const type = PROJDASH.FETCH_WIDGET_APIDATA_REJECTED;
        const newError = { errorId, type, error: err.response.data };
        actionScripts.ADD_ERROR.run(newError);
        console.log(PROJDASH.FETCH_WIDGET_APIDATA_REJECTED, err.response.data);
      });
  });
